<template>
<div class="white-title">
  <div class="white-title__container">
    <h3 class="white-title__title">
      <slot></slot>
    </h3>
  </div>
</div>
</template>

<script>
export default {
  props: {
    whiteTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.white-title {
  &__container {
    padding: 40px 180px 0;

    @media (max-width: 1275px) {
      padding: 30px 50px 0;
    }

    @media (max-width: 480px) {
      padding: 30px 20px 0;
    }
  }

  &__title {
    color: #fff;
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    text-transform: uppercase;
    @media (max-width: 720px) {
      font-size: 18px;
      line-height: 26px;
    }
  }
}
</style>
